/* Short, optional full-screen world transitions. Shopify commerce stays native. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) {
    var start = function () { api.install(root, root.document); };
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var WORLDS = ['snackshark', 'halloween', 'sparhelden'];
  var STORAGE_KEY = 'ss:last-world';
  var DURATION = 450;
  var RECOVERY_DELAY = 900;
  var PARTICLE_COUNT = 12;
  function isWorld(value) { return WORLDS.indexOf(value) !== -1; }
  function safeUrl(href, currentHref) {
    try {
      var url = new URL(href, currentHref);
      return url.protocol === 'http:' || url.protocol === 'https:' ? url : null;
    } catch (_) { return null; }
  }
  function withPreview(href, currentHref) {
    var target = safeUrl(href, currentHref);
    var current = safeUrl(currentHref, currentHref);
    if (!target || !current) return href;
    var preview = current.searchParams.get('preview_theme_id');
    if (preview && target.origin === current.origin) target.searchParams.set('preview_theme_id', preview);
    return target.href;
  }
  function sameDocument(first, second) {
    return first.origin === second.origin && first.pathname === second.pathname && first.search === second.search;
  }
  function navigationDecision(input) {
    if (!isWorld(input.world) || input.defaultPrevented || input.button !== 0 || input.metaKey || input.ctrlKey || input.shiftKey || input.altKey || input.download) return null;
    if (input.target && input.target.toLowerCase() !== '_self') return null;
    if (!input.href || input.href.trim().charAt(0) === '#') return null;
    var current = safeUrl(input.currentHref, input.currentHref);
    var destination = safeUrl(withPreview(input.href, input.currentHref), input.currentHref);
    if (!current || !destination || sameDocument(current, destination)) return null;
    return {
      href: destination.href,
      world: input.world,
      animate: input.transitions === true && !input.reducedMotion && input.world !== input.currentWorld && input.world !== 'snackshark'
    };
  }
  function particleLayout(index) {
    return {
      x: 8 + (index * 31) % 85,
      y: 5 + (index * 23) % 85,
      rotation: (index % 5 - 2) * 13,
      delay: index % 4 * 12,
      dx: 0, dy: 0, scale: 1
    };
  }
  function install(win, doc) {
    if (doc.documentElement.hasAttribute('data-ss-worlds-ready')) return null;
    doc.documentElement.setAttribute('data-ss-worlds-ready', 'true');
    var pending = false;
    var pendingHref = null;
    var timer = null;
    var recoveryTimer = null;
    var overlay = null;
    function remember(world) {
      if (!isWorld(world)) return;
      try { win.sessionStorage.setItem(STORAGE_KEY, world); } catch (_) { /* Privacy mode: navigation still works. */ }
    }
    function currentWorld() {
      var world = doc.body.getAttribute('data-ss-world');
      if (isWorld(world)) return world;
      try {
        var saved = win.sessionStorage.getItem(STORAGE_KEY);
        return isWorld(saved) ? saved : null;
      } catch (_) { return null; }
    }
    function refresh() {
      var pageWorld = doc.body.getAttribute('data-ss-world');
      if (isWorld(pageWorld)) remember(pageWorld);
      var active = currentWorld();
      doc.querySelectorAll('a[data-ss-world-link]').forEach(function (anchor) {
        var world = anchor.getAttribute('data-ss-world-link');
        if (!isWorld(world)) return;
        var href = anchor.getAttribute('href');
        if (href && href.trim().charAt(0) !== '#') anchor.setAttribute('href', withPreview(href, win.location.href));
        if (active === world) anchor.setAttribute('aria-current', isWorld(pageWorld) ? 'page' : 'true');
        else anchor.removeAttribute('aria-current');
      });
    }
    function cleanup() {
      if (timer !== null) win.clearTimeout(timer);
      if (recoveryTimer !== null) win.clearTimeout(recoveryTimer);
      timer = null;
      recoveryTimer = null;
      if (overlay) overlay.remove();
      overlay = null;
      pending = false;
      pendingHref = null;
    }
    function navigate(href) {
      timer = null;
      // A cancelled/blocked navigation must release the transparent particle layer.
      recoveryTimer = win.setTimeout(cleanup, RECOVERY_DELAY);
      try { win.location.assign(href); } catch (_) { cleanup(); }
    }
    function showTransition(world) {
      overlay = doc.createElement('div');
      overlay.className = 'ss-world-transition ss-world-transition--' + world;
      overlay.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < PARTICLE_COUNT; i += 1) {
        var position = particleLayout(i);
        var particle;
        if (world === 'halloween') {
          particle = doc.createElementNS('http://www.w3.org/2000/svg', 'svg');
          particle.setAttribute('viewBox', '0 0 100 100');
          particle.setAttribute('focusable', 'false');
          var path = doc.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', 'M50 4 60 34 84 16 66 40 96 50 66 60 84 84 60 66 50 96 40 66 16 84 34 60 4 50 34 40 16 16 40 34Z');
          particle.appendChild(path);
        } else {
          particle = doc.createElement('span');
          particle.textContent = i % 3 === 0 ? '%' : 'SALE';
        }
        particle.classList.add('ss-world-transition__particle');
        particle.style.setProperty('--ss-x', position.x + '%');
        particle.style.setProperty('--ss-y', position.y + '%');
        particle.style.setProperty('--ss-rotate', position.rotation + 'deg');
        particle.style.setProperty('--ss-delay', position.delay + 'ms');
        particle.style.setProperty('--ss-dx', position.dx + 'px');
        particle.style.setProperty('--ss-dy', position.dy + 'px');
        particle.style.setProperty('--ss-size', String(position.scale));
        overlay.appendChild(particle);
      }
      doc.body.appendChild(overlay);
    }
    function handleClick(event) {
      var element = event.target && (event.target.closest ? event.target : event.target.parentElement);
      var anchor = element && element.closest('a[data-ss-world-link]');
      if (!anchor) { if (pending) cleanup(); return; }
      var base = doc.querySelector('base[target]');
      var reduced = false;
      try { reduced = !!win.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (_) { /* Old browsers retain normal navigation. */ }
      var decision = navigationDecision({
        href: anchor.getAttribute('href'), currentHref: win.location.href,
        world: anchor.getAttribute('data-ss-world-link'), currentWorld: currentWorld(),
        target: anchor.getAttribute('target') || (base && base.getAttribute('target')),
        download: anchor.hasAttribute('download'), transitions: doc.body.getAttribute('data-ss-transitions') === 'true',
        designMode: !!(win.Shopify && win.Shopify.designMode),
        reducedMotion: reduced, defaultPrevented: event.defaultPrevented,
        button: event.button, metaKey: event.metaKey, ctrlKey: event.ctrlKey, shiftKey: event.shiftKey, altKey: event.altKey
      });
      if (!decision) { if (pending) cleanup(); return; }
      if (pending && pendingHref === decision.href && decision.animate) { event.preventDefault(); return; }
      if (pending) cleanup(); // A new destination or native gesture supersedes the pending switch.
      remember(decision.world);
      if (!decision.animate) return; // Unmodified native links are the fallback, including reduced motion.
      event.preventDefault();
      pending = true;
      pendingHref = decision.href;
      try { showTransition(decision.world); } catch (_) { if (overlay) overlay.remove(); overlay = null; }
      timer = win.setTimeout(function () {
        navigate(decision.href);
      }, overlay ? DURATION : 0);
    }
    doc.addEventListener('click', handleClick);
    doc.addEventListener('shopify:section:load', refresh);
    doc.addEventListener('keydown', function (event) { if (event.key === 'Escape' && pending) cleanup(); });
    win.addEventListener('pagehide', cleanup);
    win.addEventListener('pageshow', function () { cleanup(); refresh(); });
    refresh();
    return { cleanup: cleanup, refresh: refresh };
  }
  return { isWorld: isWorld, safeUrl: safeUrl, withPreview: withPreview, navigationDecision: navigationDecision, particleLayout: particleLayout, particleCount: PARTICLE_COUNT, install: install, duration: DURATION, recoveryDelay: RECOVERY_DELAY };
});
